import { useAuth } from '../contexts/AuthContext';
import { InvestmentSummaryWidget } from './widgets/InvestmentSummaryWidget';
import { TokenPricesWidget } from './widgets/TokenPricesWidget';
import { YieldHistoryWidget } from './widgets/YieldHistoryWidget';

export function Dashboard() {
  const { user } = useAuth();

  if (!user?.walletAddress) {
    return (
      <div className="min-h-screen px-4 py-8 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <header className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Dashboard</h1>
        </header>
        
        <main className="mt-8">
          <div className="bg-dark-surface border border-dark-border rounded-lg p-6 sm:p-8 text-center">
            <h3 className="text-xl sm:text-2xl font-semibold text-white mb-4">Wallet Address Required</h3>
            <p className="text-dark-text-secondary">
              <a href="/profile" className="text-brand-blue hover:text-brand-blue-light hover:underline transition-colors">
                Update your profile
              </a> to add a wallet address and view your dashboard.
            </p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen px-0 py-6 sm:px-4 sm:py-6 md:px-6 md:py-8 lg:px-8 max-w-7xl mx-auto">
      <header className="mb-6 sm:mb-8 hidden md:block">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-6">
          <div className="flex flex-col gap-2 sm:gap-3">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">
              Dashboard
            </h1>
            <p className="text-sm sm:text-base text-dark-text-secondary">
              Overview of your investment, prices and balances.
            </p>
          {user?.walletAddress && (
              <p className="font-mono text-xs sm:text-sm text-dark-text-tertiary bg-dark-surface-alt px-3 py-1.5 rounded-lg inline-block w-fit">
              Wallet: {user.walletAddress.slice(0, 6)}...{user.walletAddress.slice(-4)}
            </p>
          )}
          </div>
        </div>
      </header>
      
      <main className="mt-6 sm:mt-8">
        <div className="flex flex-col gap-6 sm:gap-8">
          <div className="flex flex-col md:flex-row items-center justify-center md:items-start md:justify-start gap-[40px] w-full">
            <TokenPricesWidget className="widget-token-prices w-full md:w-auto" />
            <InvestmentSummaryWidget className="widget-investment-summary w-full md:w-auto" />
            <YieldHistoryWidget className="widget-yield-history w-full md:w-auto" />
          </div>
          {/* Other widgets hidden but kept for modal usage */}
          {/* <TokenBalancesWidget className="widget-2" />
          <PoolPositionsWidget className="widget-3" />
          <AccountValueWidget className="widget-4" /> */}
        </div>
      </main>
    </div>
  );
}